@if (form(); as _form) {
  <form [formGroup]="_form" (ngSubmit)="onSubmit()">
    <div class="form-content">
      <div class="container-radio-buttons">
        @for (paymentMethod of paymentMethods(); track $index) {
          @switch (paymentMethod) {
            @case ('SEPA') {
              <ez-payment-method-selection-element
                controlName="paymentMethod"
                [value]="paymentMethod"
                label="Einzugsermächtigung"
                iconSrc="assets/icons/sepa.png"
                popoverText="Teilen Sie uns Ihre IBAN mit. Wir übernehmen den Rest und buchen diesen und alle folgenden Beiträge einfach und bequem von Ihrem Konto ab."
              ></ez-payment-method-selection-element>
            }
            @case ('GIRO') {
              <ez-payment-method-selection-element
                controlName="paymentMethod"
                [value]="paymentMethod"
                label="Direktüberweisung"
                iconSrc="assets/icons/sepa.png"
                popoverText="TODO"
              ></ez-payment-method-selection-element>
            }
            @case ('CREDIT_CARD') {
              <ez-payment-method-selection-element
                controlName="paymentMethod"
                [value]="paymentMethod"
                label="Kreditkarte"
                iconSrc="assets/icons/sepa.png"
                popoverText="TODO"
              ></ez-payment-method-selection-element>
            }
            @case ('PAYPAL') {
              <ez-payment-method-selection-element
                controlName="paymentMethod"
                [value]="paymentMethod"
                label="PayPal"
                iconSrc="assets/icons/paypal.png"
                popoverText="Über diesen Button können Sie sich schnell und bequem in Ihrem PayPal Account anmelden und die Zahlung abschließen."
              ></ez-payment-method-selection-element>
            }
          }
        }
      </div>
      <ez-button
        buttonType="submit"
        maxWidth="300px"
        [disabled]="!_form.valid"
        label="Jetzt bezahlen"
        class="button"
      ></ez-button>
    </div>
  </form>
}
